import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  titleTextStyle: {
    lineHeight: 32,
    fontSize: 24,
    ...Fonts.type.bold,
    color: Colors.mono6,
  },
  container: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },

  titleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  subTitleTextStyle: {
    color: Colors.secondary7,
    fontSize: 16.6,
    marginRight: 12,
  },
});
